/**
 * Centralized price utilities for NFT pricing
 * 
 * PRICE SYSTEM:
 * - All NFT prices are stored in USD (database field: price, current_price)
 * - USD is the primary/stable reference value
 * - EMON is calculated from USD using real-time rate (variable)
 * 
 * Display format: $X.XX USD ≈ Y,YYY EMON
 */

/**
 * Converts database price to USD
 * Handles legacy SOL values (< 0.01) by converting them
 * New values are already in USD
 */
export const priceToUsd = (price: number): number => {
  // All prices are stored in USD - no conversion needed
  return price;
};

/**
 * Formats USD price for display
 */
export const formatUsdPrice = (usdPrice: number): string => {
  return `$${usdPrice.toFixed(2)}`;
};

/**
 * Formats EMON price for display (no decimals, with thousand separators)
 */
export const formatEmonPrice = (emonPrice: number): string => {
  return emonPrice.toLocaleString(undefined, { maximumFractionDigits: 0 });
};

/**
 * Gets display price from NFT data (current_price or fallback to price)
 */
export const getNftDisplayPrice = (nft: { current_price?: number | null; price: number }): number => {
  return nft.current_price ?? nft.price;
};

/**
 * Gets USD price from NFT data, handling legacy values
 */
export const getNftUsdPrice = (nft: { current_price?: number | null; price: number }): number => {
  return priceToUsd(getNftDisplayPrice(nft));
};
